<div class="image-gallery mb-8" [attr.data-testid]="imageGalleryId" [class]="isDisabled() ? 'disabled' : ''">
    @if (isEditing() && isCaseDetail()) {
        <div class="image-gallery__upload mb-2" [attr.data-testid]="imageGalleryInput">
            <mat-icon class="material-symbols-outlined">cloud_upload</mat-icon>
            <span class="text-default" id="fileInput-text"> {{ getDictionaryItem("addNewFiles") }} </span>
            <input
                type="file"
                id="fileInput"
                name="fileInput"
                aria-describedby="fileInput-text"
                accept="image/*,.doc,.docx,.pdf,.xlsx,.pptx"
                multiple
                (change)="addNewFiles($event)"
                (drop)="addNewFiles($event)"
            />
            <div class="sr-only" aria-live="polite" id="file-selection-feedback">
                {{ selectedFilesMessage }}
            </div>
        </div>
        <div class="image-gallery__images" [attr.data-testid]="imageGalleryImageList">
            @for (image of casefileImages; track image.annotationid; let index = $index) {
                <figure
                    class="image-gallery__image-figure"
                    [class]="removeFilesList.includes(image) ? 'removed' : ''"
                    [attr.data-testid]="imageGalleryImage + (index + 1).toString().padStart(2, '0')"
                >
                    @if (image && !image.mediatype.startsWith("image/")) {
                        <div [attr.id]="'file-' + index" target="_blank" class="image-gallery__icon-wrapper">
                            <mat-icon class="material-symbols-outlined">{{ getIcon(image.mediatype) }} </mat-icon>
                        </div>
                    } @else {
                        <img
                            [src]="getFileDataString(image)"
                            [attr.id]="'file-' + index"
                            [class]="removeFilesList.includes(image) ? 'removed' : ''"
                            [attr.alt]="image.filename"
                        />
                        <button
                            (click)="openImageDialog(getFileDataString(image))"
                            class="image-gallery__dialog-button"
                            type="button"
                            aria-label="Åben billede i dialog"
                            [title]="'Åben billede i dialog'"
                        >
                            <mat-icon class="material-symbols-outlined">zoom_in</mat-icon>
                        </button>
                    }
                    <button
                        mat-icon-button
                        (click)="removeCaseFile(image)"
                        [attr.id]="'remove-' + index"
                        class="image-gallery__delete-button"
                        [attr.aria-controls]="'file-' + index"
                        [attr.aria-label]="'Fjern fil ' + image.filename"
                        [attr.data-testid]="imageGalleryRemoveButton + (index + 1).toString().padStart(2, '0')"
                        type="button"
                    >
                        <mat-icon class="material-symbols-outlined">close</mat-icon>
                    </button>
                </figure>
            }
        </div>
    }

    @if (!isCaseDetail() && !isEditing()) {
        <div class="image-gallery__upload" [attr.data-testid]="imageGalleryInput">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">cloud_upload</mat-icon>
            <span class="text-default" id="fileInput-text"> {{ getDictionaryItem("addFiles") }} </span>
            <input
                type="file"
                id="fileInput"
                name="fileInput"
                aria-labelledby="fileInput-text"
                accept="image/*,.doc,.docx,.pdf,.xlsx,.pptx"
                multiple
                (change)="selectFiles($event)"
                (drop)="selectFiles($event)"
            />
            <div class="sr-only" aria-live="polite" id="file-selection-feedback">
                {{ selectedFilesMessage }}
            </div>
        </div>
        <div class="image-gallery__images" [attr.data-testid]="imageGalleryImageList">
            @for (image of previewFiles; track image.title; let index = $index) {
                <figure class="image-gallery__image-figure" [attr.data-testid]="imageGalleryImage + (index + 1).toString().padStart(2, '0')">
                    @if (image && !image.url.startsWith("data:image/")) {
                        <div [attr.id]="'file-' + index" target="_blank" class="image-gallery__icon-wrapper">
                            <mat-icon class="material-symbols-outlined">{{ getIcon(image.url) }} </mat-icon>
                        </div>
                    } @else if (image) {
                        <img [src]="getAnnotationFile(image.url)" [attr.id]="'file-' + index" alt="" />
                        <button
                            (click)="openImageDialog(getAnnotationFile(image.url))"
                            class="image-gallery__dialog-button"
                            type="button"
                            aria-label="Åben billede i dialog"
                            [title]="'Åben billede i dialog'"
                        >
                            <mat-icon class="material-symbols-outlined">zoom_in</mat-icon>
                        </button>
                    }
                    <button
                        mat-icon-button
                        (click)="removeFile(index)"
                        [attr.data-testid]="imageGalleryRemoveButton + (index + 1).toString().padStart(2, '0')"
                        class="image-gallery__delete-button"
                        [attr.title]="'Fjern vedhæftet fil' + index"
                        [attr.id]="'remove-' + index"
                        [attr.aria-controls]="'file-' + index"
                        [attr.aria-label]="'Fjern vedhæftet fil ' + index"
                        [attr.data-testid]="imageGalleryRemoveButton + (index + 1).toString().padStart(2, '0')"
                        type="button"
                    >
                        <mat-icon class="material-symbols-outlined">close</mat-icon>
                    </button>
                </figure>
            }
        </div>
    }

    @if (isCaseDetail() && !isEditing()) {
        <span id="case-text-area" class="h4 mb-1"> {{ getDictionaryItem("attachedFiles") }} </span>
        <div class="image-gallery__images" [attr.data-testid]="imageGalleryImageList">
            @for (image of caseImages(); track image.annotationid; let index = $index) {
                <figure
                    class="image-gallery__image-figure image-gallery__image-figure--small"
                    [attr.data-testid]="imageGalleryImage + (index + 1).toString().padStart(2, '0')"
                >
                    @if (image.documentBody && !image.mediatype.startsWith("image/")) {
                        <button
                            (click)="showDocument(image)"
                            target="_blank"
                            class="image-gallery__icon-wrapper image-gallery__icon-wrapper--small"
                            aria-label="Hent fil i nyt vindue"
                            type="button"
                            [title]="'Hent fil i nyt vindue'"
                        >
                            <mat-icon class="material-symbols-outlined">{{ getIcon(image.mediatype) }} </mat-icon>
                        </button>
                    } @else if (image.documentBody) {
                        <img [src]="getFileDataString(image)" alt="" />
                        <button
                            (click)="openImageDialog(getFileDataString(image))"
                            class="image-gallery__dialog-button image-gallery__dialog-button--small"
                            type="button"
                            aria-label="Åben billede i dialog"
                            [title]="'Åben billede i dialog'"
                        >
                            <mat-icon class="material-symbols-outlined">zoom_in</mat-icon>
                        </button>
                    }
                </figure>
            }
        </div>
    }

    @if (isDragOver) {
        <div class="drag-overlay" id="drag-overlay" role="alert" aria-live="assertive" [attr.data-testid]="imageGalleryDragOverlay">
            <div class="drag-overlay__content">
                <mat-icon class="material-symbols-outlined">cloud_upload</mat-icon>
                <p>{{ getDictionaryItem("dragOverlay") }}</p>
            </div>
        </div>
    }
</div>
